import React from "react";
import { Link, useNavigate } from "react-router-dom";
import SearchOffIcon from "@mui/icons-material/SearchOff";

/**
 * 404.
 *
 * Was a full-black screen in an otherwise light application, which read as a
 * crash rather than a missing page, and offered only history.back() - a dead
 * end if the bad URL was the first page opened. It now matches the rest of the
 * panel and always offers a way home.
 *
 * min-h-dvh rather than min-h-screen so mobile browser chrome does not push the
 * content out of view.
 */
const NotFoundPage = () => {
    const navigate = useNavigate();

    return (
        <main className="flex min-h-dvh flex-col items-center justify-center gap-lg bg-canvas px-xl text-center">
            <span className="flex h-[6.4rem] w-[6.4rem] items-center justify-center rounded-pill bg-surface-sunken text-ink-subtle">
                <SearchOffIcon sx={{ fontSize: "3.2rem" }} />
            </span>

            <div>
                <h1 className="text-2xl font-semibold text-ink">
                    این صفحه پیدا نشد
                </h1>
                <p className="mt-xs max-w-[44ch] text-base text-ink-muted">
                    ممکنه آدرس عوض شده باشه یا این صفحه دیگه وجود نداشته باشه.
                </p>
            </div>

            <div className="flex flex-wrap items-center justify-center gap-sm">
                <Link
                    to="/dashboard/home"
                    className="rounded-soft bg-primary px-xl py-sm text-base text-white transition-colors duration-150 hover:bg-primary-hover focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary motion-reduce:transition-none"
                >
                    رفتن به داشبورد
                </Link>
                <button
                    type="button"
                    onClick={() => navigate(-1)}
                    className="rounded-soft border border-rule px-xl py-sm text-base text-ink-muted transition-colors duration-150 hover:bg-surface-sunken hover:text-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary motion-reduce:transition-none"
                >
                    بازگشت
                </button>
            </div>
        </main>
    );
};

export default NotFoundPage;
